import { cafeConfiguration, marketConfiguration } from '../theme/appConfiguration';

export function baseUrl() {  
    if (window.location.href.startsWith("http://localhost:")) {
        return "https://localhost:44362";

    }
    // Line below will be removed by TeamCity
    
    return "/cafe";  
}

export const getConfig = () => {

    //REPLACECONFIG


    return cafeConfiguration;
    //return marketConfiguration;
}

export const cacheBust = () => {

    return 8059
    

    return Date.now().toString();
}

export const continueFromInitialPage = (history: any, boundSetHasStartedApp: any, pathname: string) => {
    boundSetHasStartedApp(() => {
        history.push(pathname);
    });    
}